import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import { Stack } from "@mui/material";

import BreadcrumbNavigation from "../../../common/components/tabs/BreadcrumbNavigation";
import mqttPublish from "../../../common/helpers/mqttFetchHandler";
import { useStreamProcesses } from "../../../common/hooks/useStreamProcesses";
import { extractDeviceNameFromId } from "../../../common/utils/getEntityName";
import { IDeviceTableRow, IModel } from "../hooks/useDeviceTableRows";
import useGetDeviceByUrl from "../hooks/useGetDeviceByUrl";
import CreateZoneContent from "./CreateZoneContent";
import CreateZonePageHeader from "./CreateZonePageHeader";

const CreateZonePage = (): JSX.Element => {
  const { state } = useLocation();

  const device = state?.deviceDatum as IDeviceTableRow;

  const { fetchDevice, isServiceLoaded } = useGetDeviceByUrl();

  const { startStreaming, stopStreaming } = useStreamProcesses();

  const { startModelAction, stopModelAction } = mqttPublish();

  const [deviceDetail, setDeviceDetail] = useState<IDeviceTableRow | null>(
    null
  );

  useEffect((): void => {
    if (isServiceLoaded && fetchDevice) {
      fetchDevice()?.then((device): void => {
        if (device) {
          setDeviceDetail(device);

          const runningService =
            device.deviceData?.hasPanTilt &&
            device.models?.find((model: IModel) => model.isRunning);

          if (runningService) {
            const serviceType: string = runningService.serviceName;

            const { extractedDeviceName } = extractDeviceNameFromId(
              device.rowId
            );

            stopModelAction({
              modelName: serviceType,
              instanceName: extractedDeviceName,
              nodeId: device.node.id,
            });
          }

          startStreaming(device);
        }
      });
    }
  }, [isServiceLoaded]);

  useEffect(() => {
    return () => {
      if (deviceDetail) {
        const runningService =
          deviceDetail.deviceData?.hasPanTilt &&
          deviceDetail.models?.find((model: IModel) => model.isRunning);

        if (runningService) {
          const { extractedDeviceName } = extractDeviceNameFromId(
            deviceDetail.rowId
          );

          const serviceType: string = runningService.serviceName;

          startModelAction({
            modelName: serviceType,
            instanceName: extractedDeviceName,
            nodeId: device.node.id,
          });
        }

        stopStreaming(deviceDetail);
      }
    };
  }, [deviceDetail]);

  const breadcrumbItems = [
    { label: "Devices", path: "/devices" },
    {
      label: device?.name,
      path: "/device/" + encodeURIComponent(device.rowId),
    },
    { label: "Create Zone" },
  ];

  return (
    <Stack spacing={2} direction="column">
      <BreadcrumbNavigation items={breadcrumbItems} />
      <CreateZonePageHeader />
      <CreateZoneContent />
    </Stack>
  );
};

export default CreateZonePage;
